import React, { useState } from 'react';
import { Modal, Button, Space, Typography, Spin } from 'antd';
import { EyeOutlined, LinkOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface WebsitePreviewProps {
  websiteId: string;
  websiteDomain: string;
  visible: boolean;
  onClose: () => void;
}

const WebsitePreview: React.FC<WebsitePreviewProps> = ({
  websiteId,
  websiteDomain,
  visible,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string>('');

  const handlePreview = () => {
    setLoading(true);
    // Construct preview URL
    const url = `http://localhost/${websiteDomain}`;
    setPreviewUrl(url);
    setLoading(false);
  };

  const handleOpenInNewTab = () => {
    if (previewUrl) {
      window.open(previewUrl, '_blank');
    }
  };

  return (
    <Modal
      title={
        <Space>
          <EyeOutlined />
          <span>Website Preview</span>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      width="90%"
      style={{ top: 20 }}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="preview"
          type="primary"
          icon={<EyeOutlined />}
          onClick={handlePreview}
          loading={loading}
        >
          Load Preview
        </Button>,
        <Button
          key="external"
          icon={<LinkOutlined />}
          onClick={handleOpenInNewTab}
          disabled={!previewUrl}
        >
          Open in New Tab
        </Button>,
      ]}
    >
      <div style={{ height: '70vh' }}>
        {!previewUrl ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              textAlign: 'center',
            }}
          >
            <Title level={3}>Website Preview</Title>
            <Text type="secondary" style={{ marginBottom: 24 }}>
              Click "Load Preview" to see how your website looks
            </Text>
            <Space direction="vertical" size="large">
              <div>
                <Text strong>Website Domain:</Text> {websiteDomain}
              </div>
              <div>
                <Text strong>Preview URL:</Text> http://localhost/{websiteDomain}
              </div>
            </Space>
          </div>
        ) : (
          <div style={{ height: '100%', position: 'relative' }}>
            {loading && (
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1000,
                }}
              >
                <Spin size="large" />
              </div>
            )}
            <iframe
              src={previewUrl}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                borderRadius: 8,
              }}
              title="Website Preview"
              onLoad={() => setLoading(false)}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default WebsitePreview;
